import store from '../../store';
import Errors from '../../Errors';
import CartHelpersMixin from '../../mixins/CartHelpersMixin';
import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';
import { Loader } from '@googlemaps/js-api-loader';
import flatpickr from 'flatpickr';
import { Spanish } from "flatpickr/dist/l10n/es.js"

require("flatpickr/dist/flatpickr.css")

export default {
    mixins: [
        CartHelpersMixin,
        ProductHelpersMixin,
    ],

    props: [
        'customerEmail',
        'customerPhone',
        'gateways',
        'defaultAddress',
        'addresses',
        'countries',
        'customerName',
        'customerLastname',
        'minimumDate',
        'expressDeliveriesDisabledOn',
        'standardShippingTime1DisabledOn',
        'standardShippingTime2DisabledOn',
    ],

    async mounted() {
        const loader = new Loader({
            apiKey: "AIzaSyBWZV8NrnsqNM8eh6llkewZsT4L4jzFFww",
            version: "weekly",
            libraries: ["places"]
        });

        const myLatLng = { lat: this.defaultLatitude, lng: this.defaultLongitude };
        const mapOptions = {
            center: myLatLng,
            zoom: 18,
            mapTypeControl: false,
            fullscreenControl: false,
        };

        flatpickr('#delivery_date', {
            altInput: true,
            "locale": Spanish,
            disable: store.state.cart.disabledDates,
            minDate: this.minimumDate
        });

        this.form.disabled_dates = store.state.cart.disabledDates;

        loader
            .load()
            .then((google) => {
                const mapContainer = this.$refs.googleMap
                const card = this.$refs.mapCard
                const input = this.$refs.mapInput
                this.map = new google.maps.Map(mapContainer, mapOptions);
                let vm = this;

                this.marker = new google.maps.Marker({
                    position: myLatLng,
                    map: this.map,
                    draggable: true,
                    clickable: true,
                    animation: google.maps.Animation.DROP,
                });

                const options = {
                    fields: ["formatted_address", "geometry", "name"],
                    strictBounds: false,
                    types: ["establishment"],
                };

                this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(card);

                const autocomplete = new google.maps.places.Autocomplete(input, options);

                autocomplete.bindTo("bounds", this.map);

                const infowindow = new google.maps.InfoWindow();
                const infowindowContent = this.$refs.mapInfoWindow;
                infowindow.setContent(infowindowContent);

                autocomplete.addListener("place_changed", () => {
                    infowindow.close();
                    this.marker.setVisible(false);

                    const place = autocomplete.getPlace();

                    if (!place.geometry || !place.geometry.location) {
                        window.alert("No details available for input: '" + place.name + "'");
                        return;
                    }

                    if (place.geometry.viewport) {
                        this.map.fitBounds(place.geometry.viewport);
                    } else {
                        this.map.setCenter(place.geometry.location);
                        this.map.setZoom(17);
                    }

                    this.marker.setPosition(place.geometry.location);
                    this.marker.setVisible(true);
                    infowindowContent.children["place-name"].textContent = place.name;
                    infowindowContent.children["place-address"].textContent = place.formatted_address;
                    infowindow.open(this.map, this.marker);

                    this.form.shipping.latitude = place.geometry.location.lat();
                    this.form.shipping.longitude = place.geometry.location.lng();
                });

                google.maps.event.addListener(this.marker, 'dragend', function (marker) {
                    var latLng = marker.latLng;
                    vm.form.shipping.latitude = latLng.lat();
                    vm.form.shipping.longitude = latLng.lng();
                    var latlng = {
                        lat: latLng.lat(),
                        lng: latLng.lng(),
                    };
                    var geocoder = new google.maps.Geocoder;
                    geocoder.geocode({
                        'location': latlng
                    }, function (results, status) {
                        if (status === 'OK') {
                            if (results[0]) {
                                input.value = results[0].formatted_address;
                            } else {
                                window.alert('No results found');
                            }
                        } else {
                            window.alert('Geocoder failed due to: ' + status);
                        }
                    });
                });
            })
            .catch(e => {
                // do something
            });
    },

    data() {
        return {
            form: {
                min_date: this.formatActualDate(),
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {
                    address_1: 'Lima',
                    city: 'Lima',
                    zip: 'Lima',
                    country: 'PE',
                    state: 'LIM',
                    first_name: this.customerName,
                    last_name: this.customerLastname,
                },
                shipping: {
                    zip: 'Lima',
                    country: 'PE',
                    state: 'LIM',
                    address_type: '',
                    address_type_name: '',
                    latitude: '',
                    longitude: '',
                    zone_name: '',
                    zone_code: '',
                    phone: '',
                },
                billingAddressId: null,
                shippingAddressId: null,
                newBillingAddress: false,
                newShippingAddress: false,
                ship_to_a_different_address: true,
                selected_district: null,
                selected_address_type: null,
                shipping_type: null,
                receives_third: true,
                shipping_price: 0,
                delivery_date: null,
                delivery_time: null,
                disabled_dates: null,
            },
            states: {
                billing: {},
                shipping: {},
            },
            districts: [],
            addressTypes: [],
            placingOrder: false,
            errors: new Errors(),
            stripe: null,
            stripeCardElement: null,
            stripeError: null,
            payuError: null,
            map: null,
            marker: null,
            defaultLatitude: -12.0266034,
            defaultLongitude: -77.1278633,
            shippingTypes: [
                {
                    id: 'estandar',
                    label: 'Envío Estandar',
                    description: '',
                    value: '0',
                    enabled: true,
                },
                {
                    id: 'express',
                    label: 'Envío Express',
                    description: 'NO valido para feriados',
                    value: '1',
                    enabled: true,
                }
            ],
            shippingTimes: [
                {
                    value: '1',
                    label: '8:00 a.m. a 5:00 p.m.',
                    type: 'standard',
                    enabled: false,
                },
                {
                    value: '2',
                    label: '5:00 p.m. a 10:30 p.m.',
                    type: 'standard',
                    enabled: false,
                },
                {
                    value: '9',
                    label: '9:00 am',
                    sql: '09:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '10',
                    label: '10:00 am',
                    sql: '10:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '11',
                    label: '11:00 am',
                    sql: '11:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '12',
                    label: '12:00 am',
                    sql: '12:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '13',
                    label: '1:00 pm',
                    sql: '13:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '14',
                    label: '2:00 pm',
                    sql: '14:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '15',
                    label: '3:00 pm',
                    sql: '15:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '16',
                    label: '4:00 pm',
                    sql: '16:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '17',
                    label: '5:00 pm',
                    sql: '17:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '18',
                    label: '6:00 pm',
                    sql: '18:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '19',
                    label: '7:00 pm',
                    sql: '19:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '20',
                    label: '8:00 pm',
                    sql: '20:00:00',
                    type: 'express',
                    enabled: false,
                },
                {
                    value: '21',
                    label: '9:00 pm',
                    sql: '21:00:00',
                    type: 'express',
                    enabled: false,
                },
            ]
        };
    },

    computed: {
        hasAddress() {
            return Object.keys(this.addresses).length !== 0;
        },

        firstCountry() {
            return Object.keys(this.countries)[0];
        },

        hasBillingStates() {
            return Object.keys(this.states.billing).length !== 0;
        },

        hasShippingStates() {
            return Object.keys(this.states.shipping).length !== 0;
        },

        hasNoPaymentMethod() {
            return Object.keys(this.gateways).length === 0;
        },

        firstPaymentMethod() {
            return Object.keys(this.gateways)[0];
        },

        shouldShowPaymentInstructions() {
            return ['bank_transfer', 'check_payment'].includes(this.form.payment_method);
        },

        paymentInstructions() {
            if (this.shouldShowPaymentInstructions) {
                return this.gateways[this.form.payment_method].instructions;
            }
        },
        firstAddress() {
            if (Object.keys(this.addresses).length > 0)
                return this.addresses[0]
        },
    },

    watch: {
        'form.billingAddressId': function () {
            this.mergeSavedAddresses();
        },

        'form.shippingAddressId': function () {
            this.mergeSavedAddresses();
        },

        'form.billing.city': function (newCity) {
            if (newCity) {
                this.addTaxes();
            }
        },

        'form.shipping.city': function (newCity) {
            if (newCity) {
                this.addTaxes();
            }
        },

        'form.billing.zip': function (newZip) {
            if (newZip) {
                this.addTaxes();
            }
        },

        'form.shipping.zip': function (newZip) {
            if (newZip) {
                this.addTaxes();
            }
        },

        'form.billing.state': function (newState) {
            if (newState) {
                this.addTaxes();
            }
        },

        'form.shipping.state': function (newState) {
            if (newState) {
                this.addTaxes();
            }
        },

        'form.ship_to_a_different_address': function () {
            this.addTaxes();
        },

        'form.terms_and_conditions': function () {
            this.errors.clear('terms_and_conditions');
        },

        'form.payment_method': function (newPaymentMethod) {
            if (newPaymentMethod === 'paypal') {
                this.$nextTick(this.renderPayPalButton);
            }

            if (newPaymentMethod !== 'stripe') {
                this.stripeError = '';
            }

            if (newPaymentMethod !== 'payu') {
                this.payuError = '';
            }
        },

        'form.shipping_type': function (newShippingType) {
            this.form.delivery_time = null;
            if (newShippingType === '1') {
                this.shippingTimes.map((element, index) => element.type == 'express' ? this.shippingTimes[index] = { ...element, enabled: true } : this.shippingTimes[index] = { ...element, enabled: false });
                this.form.shipping_price = (this.form.selected_district) ? this.form.selected_district.express : 0;
            } else if (newShippingType === '0') {
                this.shippingTimes.map((element, index) => element.type == 'standard' ? this.shippingTimes[index] = { ...element, enabled: true } : this.shippingTimes[index] = { ...element, enabled: false });
                this.form.shipping_price = (this.form.selected_district) ? this.form.selected_district.standard : 0;
                
                let fechasConTurno1Deshabilitado = this.standardShippingTime1DisabledOn.split(', ');
                let fechasConTurno2Deshabilitado = this.standardShippingTime2DisabledOn.split(', ');
                let deliveryDate = new Date(document.getElementById('delivery_date').value);
                if (fechasConTurno1Deshabilitado.includes(this.formatDate(deliveryDate))) {
                    this.shippingTimes[0].enabled = false;
                }
                if (fechasConTurno2Deshabilitado.includes(this.formatDate(deliveryDate))) {
                    this.shippingTimes[1].enabled = false;
                }
            }
        },

        'form.selected_district': function (newDistrict) {
            this.shippingTypes[0].label = `Envío Estandar S/ ${newDistrict.standard.toFixed(2)}`;
            this.shippingTypes[1].label = `Envío Express S/ ${newDistrict.express.toFixed(2)}`;
            this.form.shipping_price = (this.form.shipping_type) ? ((this.form.shipping_type === '1') ? newDistrict.express : newDistrict.standard) : 0;
        },

        'form.need_invoice': function (needInvoice) {
            if (needInvoice == false) {
                this.form.invoice_business_name = null;
                this.form.invoice_ruc = null;
            }
        },

        'form.confidential': function (confidential) {
            if (confidential == false) {
                this.form.confidential_pin = null;
            }
        }
    },

    created() {
        if (this.defaultAddress.address_id) {
            // this.form.billingAddressId = this.defaultAddress.address_id;
            this.form.shippingAddressId = this.defaultAddress.address_id;
        }

        if (!this.hasAddress) {
            this.form.newBillingAddress = false;
            this.form.newShippingAddress = true;

            this.changeBillingCountry(this.firstCountry);
            this.changeShippingCountry(this.firstCountry);
        }

        this.fetchDistricts((districts) => {
            districts.map(district => {
                this.districts.push(district);
                if (this.defaultAddress.address_id && district.value == this.defaultAddress.address.zone_code) {
                    this.form.selected_district = district;
                }
            });
        });

        this.fetchAddressTypes((addressTypes) => {
            addressTypes.map(type => this.addressTypes.push(type));
        });

        this.$nextTick(() => {
            this.changePaymentMethod(this.firstPaymentMethod);

            if (store.state.cart.shippingMethodName) {
                this.changeShippingMethod(store.state.cart.shippingMethodName);
            } else {
                this.updateShippingMethod(this.firstShippingMethod);
            }

            if (window.Stripe) {
                this.stripe = window.Stripe(FleetCart.stripePublishableKey);

                this.renderStripeElements();
            }
        });
    },

    methods: {
        formatActualDate() {
            let today = new Date();
            let dd = today.getDate();

            let mm = today.getMonth() + 1;
            const yyyy = today.getFullYear();
            if (dd < 10) {
                dd = `0${dd}`;
            }

            if (mm < 10) {
                mm = `0${mm}`;
            }

            return `${yyyy}-${mm}-${dd}`;
        },
        addNewBillingAddress() {
            this.errors.reset();

            this.form.billing = {};
            this.form.newBillingAddress = !this.form.newBillingAddress;
        },

        addNewShippingAddress() {
            this.errors.reset();

            this.form.shipping = {
                zip: 'Lima',
                country: 'PE',
                state: 'LIM',
                address_type: '',
                address_type_name: '',
                latitude: '',
                longitude: '',
                zone_name: '',
                zone_code: '',
                phone: '',
            };
            this.form.newShippingAddress = !this.form.newShippingAddress;
            this.form.shippingAddressId = null;
        },

        mergeSavedAddresses() {
            if (!this.form.newBillingAddress && this.form.billingAddressId) {
                this.form.billing = this.addresses[this.form.billingAddressId];
            }

            if (
                this.form.ship_to_a_different_address
                && !this.form.newShippingAddress
                && this.form.shippingAddressId
            ) {
                this.form.shipping = this.addresses[this.form.shippingAddressId];
            }
        },

        changeBillingCity(city) {
            this.$set(this.form.billing, 'city', city);
        },

        changeShippingCity(city) {
            this.$set(this.form.shipping, 'city', this.form.selected_district.distrito);
            this.$set(this.form.shipping, 'zone_name', this.form.selected_district.name);
            this.$set(this.form.shipping, 'zone_code', this.form.selected_district.value);
            this.$set(this.form.shipping, 'map_address', `${this.form.shipping.address_1} ${this.form.shipping.city}`);
        },

        changeBillingZip(zip) {
            this.$set(this.form.billing, 'zip', zip);
        },

        changeShippingZip(zip) {
            this.$set(this.form.shipping, 'zip', zip);
        },

        changeBillingCountry(country) {
            this.$set(this.form.billing, 'country', country);

            this.fetchStates(country, (states) => {
                this.$set(this.states, 'billing', states);
                this.$set(this.form.billing, 'state', 'LIM');
            });
        },

        changeShippingCountry(country) {
            this.$set(this.form.shipping, 'country', country);

            this.fetchStates(country, (states) => {
                this.$set(this.states, 'shipping', states);
                this.$set(this.form.shipping, 'state', 'LIM');
            });
        },

        changeShippingAddressType(type) {
            this.$set(this.form.shipping, 'address_type', this.form.selected_address_type.value);
            this.$set(this.form.shipping, 'address_type_name', this.form.selected_address_type.name);
        },

        changeShippingAddress(address) {
            this.form.selected_district = this.districts.find((element) => {
                return element.value == address;
            });
        },

        fetchStates(country, callback) {
            $.ajax({
                method: 'GET',
                url: route('countries.states.index', { code: country }),
            }).then(callback);
        },

        fetchDistricts(callback) {
            $.ajax({
                method: 'GET',
                url: route('districts.index'),
            }).then(callback);
        },

        fetchAddressTypes(callback) {
            $.ajax({
                method: 'GET',
                url: route('addresstypes.index'),
            }).then(callback);
        },

        changeBillingState(state) {
            this.$set(this.form.billing, 'state', state);
        },

        changeShippingState(state) {
            this.$set(this.form.shipping, 'state', state);
        },

        changePaymentMethod(paymentMethod) {
            this.$set(this.form, 'payment_method', paymentMethod);
        },

        changeShippingMethod(shippingMethodName) {
            this.$set(this.form, 'shipping_method', shippingMethodName);
        },

        addTaxes() {
            this.loadingOrderSummary = true;

            $.ajax({
                method: 'POST',
                url: route('cart.taxes.store'),
                data: this.form,
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        placeOrder() {
            if (!this.form.terms_and_conditions || this.placingOrder) {
                return;
            }

            this.placingOrder = true;

            $.ajax({
                method: 'POST',
                url: route('checkout.create'),
                data: this.form,
            }).then((response) => {
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                } else if (this.form.payment_method === 'stripe') {
                    this.confirmStripePayment(response);
                } else if (this.form.payment_method === 'paytm') {
                    this.confirmPaytmPayment(response);
                } else if (this.form.payment_method === 'razorpay') {
                    this.confirmRazorpayPayment(response);
                } else if (this.form.payment_method === 'payu') {
                    this.confirmPayuPayment(response);
                } else {
                    this.confirmOrder(response.orderId, this.form.payment_method);
                }
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                }

                this.$notify(xhr.responseJSON.message);

                this.placingOrder = false;
            });
        },

        confirmOrder(orderId, paymentMethod, params = {}) {
            $.ajax({
                method: 'GET',
                url: route('checkout.complete.store', { orderId, paymentMethod, ...params }),
            }).then(() => {
                window.location.href = route('checkout.complete.show');
            }).catch((xhr) => {
                this.placingOrder = false;
                this.loadingOrderSummary = false;

                this.deleteOrder(orderId);
                this.$notify(xhr.responseJSON.message);
            });
        },

        deleteOrder(orderId) {
            if (!orderId) {
                return;
            }

            $.ajax({
                method: 'GET',
                url: route('checkout.payment_canceled.store', { orderId }),
            });
        },

        renderPayPalButton() {
            let vm = this;
            let response;

            window.paypal.Buttons({
                async createOrder() {
                    try {
                        response = await $.ajax({
                            method: 'POST',
                            url: route('checkout.create'),
                            data: vm.form,
                        });

                        return response.resourceId;
                    } catch (xhr) {
                        if (xhr.status === 422) {
                            vm.errors.record(xhr.responseJSON.errors);
                        } else {
                            vm.$notify(xhr.responseJSON.message);
                        }
                    }
                },
                onApprove() {
                    vm.loadingOrderSummary = true;

                    vm.confirmOrder(response.orderId, 'paypal', response);
                },
                onError() {
                    vm.deleteOrder(response.orderId);
                },
                onCancel() {
                    vm.deleteOrder(response.orderId);
                },
            }).render('#paypal-button-container');
        },

        renderStripeElements() {
            this.stripeCardElement = this.stripe.elements().create('card', {
                hidePostalCode: true,
            });

            this.stripeCardElement.mount('#stripe-card-element');
        },

        async confirmStripePayment({ orderId, clientSecret }) {
            let result = await this.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: this.stripeCardElement,
                    billing_details: {
                        email: this.form.customer_email,
                        name: `${this.form.billing.first_name} ${this.form.billing.last_name}`,
                        address: {
                            city: this.form.billing.city,
                            country: this.form.billing.country,
                            line1: this.form.billing.address_1,
                            line2: this.form.billing.address_2,
                            postal_code: this.form.billing.zip,
                            state: this.form.billing.state,
                        },
                    },
                },
            });

            if (result.error) {
                this.placingOrder = false;
                this.stripeError = result.error.message;

                this.deleteOrder(orderId);
            } else {
                this.confirmOrder(orderId, 'stripe', result);
            }
        },

        confirmPaytmPayment({ orderId, amount, txnToken }) {
            let config = {
                root: '',
                flow: 'DEFAULT',
                data: {
                    orderId: orderId,
                    token: txnToken,
                    tokenType: 'TXN_TOKEN',
                    amount: amount,
                },
                merchant: {
                    redirect: false,
                },
                handler: {
                    transactionStatus: (response) => {
                        if (response.STATUS === 'TXN_SUCCESS') {
                            this.confirmOrder(orderId, 'paytm', response);
                        } else if (response.STATUS === 'TXN_FAILURE') {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }

                        window.Paytm.CheckoutJS.close();
                    },
                    notifyMerchant: (eventName) => {
                        if (eventName === 'APP_CLOSED') {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }
                    },
                },
            };

            window.Paytm.CheckoutJS.init(config).then(() => {
                window.Paytm.CheckoutJS.invoke();
            }).catch(() => {
                this.deleteOrder(orderId);
            });
        },

        confirmRazorpayPayment(razorpayOrder) {
            this.placingOrder = false;

            let vm = this;

            new window.Razorpay({
                key: FleetCart.razorpayKeyId,
                name: FleetCart.storeName,
                description: `Payment for order #${razorpayOrder.receipt}`,
                image: FleetCart.storeLogo,
                order_id: razorpayOrder.id,
                handler(response) {
                    vm.placingOrder = true;

                    vm.confirmOrder(razorpayOrder.receipt, 'razorpay', response);
                },
                modal: {
                    ondismiss() {
                        vm.deleteOrder(razorpayOrder.receipt);
                    },
                },
                prefill: {
                    name: `${vm.form.billing.first_name} ${vm.form.billing.last_name}`,
                    email: vm.form.customer_email,
                    contact: vm.form.customer_phone,
                },
            }).open();
        },

        confirmPayuPayment(response) {
            if (response.transactionResponse.state === 'DECLINED') {
                // this.placingOrder = false;
                // this.payuError = (response.transactionResponse.responseMessage) ? response.transactionResponse.responseMessage : (response.transactionResponse.paymentNetworkResponseErrorMessage) ? response.transactionResponse.paymentNetworkResponseErrorMessage : 'Error desconocido, por favor intente con otra tarjeta.';
                // this.deleteOrder(response.orderId);
                this.confirmOrder(response.orderId, 'payu', response);
            } else if (response.transactionResponse.state === 'PENDING') {
                // this.placingOrder = false;
                // this.payuError = response.transactionResponse.pendingReason;
                this.confirmOrder(response.orderId, 'payu', response);
            } else if (response.transactionResponse.state === 'APPROVED') {
                this.confirmOrder(response.orderId, 'payu', response);
            }
        },

        resizeMap() {
            if (typeof this.map == "undefined") return;
            setTimeout(() => {
                this.resizingMap();
            }, 400);
        },

        resizingMap() {
            if (typeof this.map == "undefined") return;
            var center = this.map.getCenter();
            google.maps.event.trigger(this.map, "resize");
            this.map.setCenter(center);
        },

        onShippingAddressChange(address) {
            this.$set(this.form.shipping, 'map_address', `${address} ${this.form.shipping.city}`);
        },

        onShippingDateChange(date) {
            let fechasConExpressDeshabilitado = this.expressDeliveriesDisabledOn.split(', ');
            this.form.shipping_type = null;
            let deliveryDate = new Date(date);
            if (deliveryDate.getDay() == 6 || fechasConExpressDeshabilitado.includes(this.formatDate(deliveryDate)))
                this.shippingTypes[1].enabled = false;
            else
                this.shippingTypes[1].enabled = true;
        },
        formatDate(date) {
            // Establecer la zona horaria en UTC
            date.setUTCHours(0, 0, 0, 0);
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const day = String(date.getUTCDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    },
};